import { useIsUserAuthenticated, useIsUserCompany } from '../../common/hooks/useUserProfile';
import { isInB2BCrossContext, useIsB2BRoute } from '../../common/utils/b2bUtils';

export const useIsB2bCrossContext = () => {
    const isUserCompany = useIsUserCompany();
    const isB2b = useIsB2BRoute();
    const isAuthenticated = useIsUserAuthenticated();
    const { privateCartOnCompanySite, companyUserOnPrivateSite, privateUserOnCompanySite } =
        isInB2BCrossContext({
            isB2BRoute: isB2b,
            isUserCompany,
            isAuthenticated,
        });

    return {
        privateCartOnCompanySite,
        companyUserOnPrivateSite,
        privateUserOnCompanySite,
    };
};
